import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { FileRecord } from "@/shared/domain/files";

import { fileQueryKeys } from "./fileQueryKeys";

interface RenameFileProps {
  fileId: string;
  associationId: string;
  currentPath: string;
  newName: string;
}

export function useRenameFile() {
  const { files: fileService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<FileRecord, Error, RenameFileProps>({
    mutationFn: ({ fileId, associationId, currentPath, newName }) => {
      return fileService.renameFile(
        fileId,
        associationId,
        currentPath,
        newName,
      );
    },
    onSuccess: (file) => {
      queryClient.setQueryData(fileQueryKeys.detail(file.file_id), file);
      return queryClient.invalidateQueries({
        queryKey: fileQueryKeys.directoryContents(),
      });
    },
  });
}
